import React, {useState} from "react";
//import { useRoute } from '@react-navigation';
import TourButton from "../TourButton/TourButton";
import welcomeLight from "../../assets/images/welcome.png";
import welcomeDark from "../../assets/images/welcome-dark.png";

import Joyride, {STATUS} from "react-joyride"
import {useNavigate} from "react-router";
import {ThemedImage} from "../ui/ThemedImage";

const Hero = () => {
    const navigate = useNavigate()
    const [state, setState] = useState({
        run: false
    })
    const locale = {
        back: 'Geri',
        close: 'Kapat',
        last: 'Son',
        next: 'İleri',
        skip: "Atla"
    }
    const startTour = () => {
        setState({run: true})
    }
    const handleJoyrideCallback = (data: any) => {
        const {status} = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];
        if (finishedStatuses.includes(status)) {
            setState({run: false})
        }
    };
    const goToUpdateLicense = () => {
        navigate("/offline-actions")
    }
    return (
        <div>
            <section className="py-14">
                {state.run ?
                    <Joyride continuous callback={handleJoyrideCallback} run={state.run} steps={[

                        {
                            content: <h2>Merhabalar, bilgilendirme turumuza HOŞGELDİNİZ.</h2>,
                            placement: "center",
                            target: "body"
                        },
                        {
                            content: <h2>Buradaki butona basarak Çevrimdışı işlemler bölümüne geçebilirsiniz</h2>,
                            placement: "top",
                            target: "#welcome"
                        },
                    ]}
                             hideCloseButton
                             locale={locale}
                             scrollToFirstStep showSkipButton showProgress/> : ''}
                <div className="max-w-screen-xl mx-auto px-4 md:text-center md:px-8">
                    <div className="max-w-xl md:mx-auto text-center">
                        <div className='max-w-xs mx-auto '>
                            <ul className='sm:grid sm:space-y-0'>
                                <li className={'flex justify-center items-center gap-4 '}>
                                    <ThemedImage lightSrc={welcomeLight} darkSrc={welcomeDark} alt={"oska-hosgediniz"} className="border-none outline-none shadow-none bg-transparent"/>
                                </li>
                            </ul>
                        </div>
                        <h3 className="text-gray-800 text-3xl font-semibold sm:text-4xl dark:text-white">
                            Oska Asistana Hoşgeldiniz
                        </h3>
                        <p className="mt-3 text-gray-600 dark:text-gray-300">
                            Oska asistan ile HakedişPlus&apos;ta çevrimdışı işlemlerinizi kolayca halledebilirsiniz.
                        </p>

                    </div>
                    <div className="flex gap-3 hover:cursor-pointer items-center mt-4 md:justify-center" id="welcome">
                        <button
                            onClick={goToUpdateLicense}
                            className="inline-block text-center w-full  py-2 px-4 text-white font-medium  sm:w-auto bg-blue-600 hover:bg-blue-800 rounded-md shadow">
                            Başla
                        </button>
                    </div>
                </div>
            </section>
            <TourButton onClick={startTour}/>
        </div>
    )
}
export default Hero

